/**
 * Description: member接口
 * Author: sunc
 * Date: 2019-06-28
 * Time: 14:30
 */

export const taskApiMap = {
  // 获取我的办件
  getTaskPage: '/tasks/v1/page',
  //获取邮件信息
  mail: '/mail/tskmail/mail/',
  //撤销办件
  patch:'/tasks/v1/patch',
  //新增办件
  tsk:'/tasks/v1/tsk',
  //新增定制化办件
  tskCustom:'tasks/custom/v1/tsk',
  //获取办件信息
  tskNum:'/tasks/v1/numvalid',
  //查看材料附件
  att:'/tasks/v1/att',
  //附件信息
  getAttResult:'/tasks/tsk/att-result/',
  //查询网吧备案
  internetBar:'/tasks/wa/internetbarforbq',
  //办件、预约数量
  count:'/tasks/v1/tskcount',
  //前十条已处理办件
  complete:'/tasks/v1/getcomplete',
  //办件详情
  detail:'/tasks/v1/tsk/',
  //获取办件

  /**
   * 出入境事项申请地址
   */
  crjTsks: 'tasks/hubeigat/crj',
  crtTsks: 'tasks/hubeigat/temporary',
  /**
   * 行政审批事项申请地址(企业)
   */
  xzspCompTsk: 'tasks/hubeigat/xzsp/company',
  /**
   * 行政审批事项申请地址(个人)
   */
  xzspPersonTsk: 'tasks/hubeigat/xzsp/person',
  /**
   * 户政统一接口
   */
  hzTsks:'/tasks/hubeigat/hz-apply',
  /**
   * 专区业务申请接口
   */
  zoneTsks:'/tasks/hubeigat/zone-apply',
  /**
   * 户政证明类申请接口
   */
  hzTsksDz:'/tasks/hubeigat/hz-apply-dz',
  /**
   * 治安典当行业申请
   */
  zaPawnTsks:'/tasks/hubeigat/public-security/impawn',
  /**
   * 治安公章刻制行业申请
   */
  zaCachetTsks:'/tasks/hubeigat/public-security/cachet',
  /**
   * 治安旅馆行业申请
   */
  zaHotelTsks:'/tasks/hubeigat/public-security/hotel',

  /**
   * 无犯罪记录证明
   */
  criminalRecord:'/tasks/hubeigat/criminalRecord',

  /**
   * 无犯罪记录证明 详情
   */
  criminalRecordInfo: '/tasks/hubeigat/criminalRecord-info/',

  criminalRecordInfoSubmit: 'tasks/hubeigat/jzCriminalTest'
}
